// extracted by mini-css-extract-plugin
export default {"wrapper":"Powered_wrapper__52BWr","heart":"Powered_heart__5eKUG","dot":"Powered_dot__InlLD"};